import { ProductsModal } from '@app/components/Modals';
import {
  useAddAvailableProductsModal,
  useAddAvailableProductsModalEffects,
} from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/hooks';
import type { AddAvailableProductsModalType } from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/types';

export const AddAvailableProductsModal: AddAvailableProductsModalType = (
  props
) => {
  const {
    checkedKeys,
    onSelect,
    onCheck,
    isOpen,
    treeData,
    searchValue,
    onSearch,
    skipFilters,
    addProducts,
    onCancel,
    checkedKeysHandler,
    suppliersOptions,
    selectedSuppliers,
    setSelectedSuppliers,
    range,
    setRange,
  } = useAddAvailableProductsModal(props);

  useAddAvailableProductsModalEffects({ checkedKeysHandler });

  const { isLoading } = props;

  return (
    <ProductsModal
      isOpen={isOpen}
      onCancel={onCancel}
      onOk={addProducts}
      searchValue={searchValue}
      onSearch={onSearch}
      treeData={treeData}
      checkedKeys={checkedKeys}
      onSelect={onSelect}
      onCheck={onCheck}
      skipFilters={skipFilters}
      title="Выбрать товар склада"
      showExtraFilters
      suppliersOptions={suppliersOptions}
      selectedSuppliers={selectedSuppliers}
      setSelectedSuppliers={setSelectedSuppliers}
      range={range}
      setRange={setRange}
      isLoading={isLoading}
    />
  );
};
